var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress"},[_c('el-progress',{attrs:{"text-inside":true,"stroke-width":20,"percentage":_vm.percentage,"color":_vm.colorList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }